import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-research-dashboard-page',
  templateUrl: './research-dashboard-page.component.html',
  styleUrls: ['./research-dashboard-page.component.css']
})
export class ResearchDashboardPageComponent implements OnInit {

  ResearchDocuments = [];
  constructor(public ds: DataService) {
    this.FetchResearchDocuments();
  }

  ngOnInit() {
  }

  FetchResearchDocuments() {

    this.ds.FetchResearchDocuments().then((res: any) => {

      let ResearchDocuments = res;
      let FinalResearchDocuments = [];

      for (const { ResearchDocName, DocCatID, DocCategoryName, DocPath } of ResearchDocuments) {
        if (!FinalResearchDocuments[DocCategoryName]) FinalResearchDocuments[DocCategoryName] = [];
        FinalResearchDocuments[DocCategoryName].push({ ResearchDocName, DocCatID, DocCategoryName, DocPath });
      }

      console.log(Object.keys(FinalResearchDocuments).forEach((item) => { this.ResearchDocuments.push({ CategoryName: item, RDData: FinalResearchDocuments[item] }) }))
      console.log(this.ResearchDocuments)
    }, (error) => {

      console.log(error);
    });
  }

}
